import type { AxiosError } from 'axios';

import type Profiler from '@rover/shared/js/ssr/Profiler';

import getStatsdTagForUrl from './getStatsdTagForUrl';

const axiosErrorHandler = (
  e?: AxiosError,
  PROFILER?: Profiler,
  PROFILER_KEYS?: Record<string, string>
): never => {
  let error: Error;

  if (e && e.config && e.config.method) {
    const isTimeout = e.code === 'ECONNABORTED';
    const apiUrl = getStatsdTagForUrl(e.config.url ?? '', 'No Match Found');
    const apiMethod = e.config.method.toUpperCase();

    if (isTimeout && PROFILER && PROFILER_KEYS) {
      PROFILER.increment({
        key: PROFILER_KEYS.API_CALL_TIMEOUT,
        tags: {
          apiMethod,
          apiUrl,
        },
      });
    }

    error = new Error(
      `axiosUtils ${isTimeout ? 'timed out' : 'errored'} while requesting "${apiMethod} ${
        e.config.url
      }": ${e.message}`
    );
  } else {
    error = new Error(String(e));
  }

  if (!(e?.response && e.response.status)) throw error;
  throw e;
};

export default axiosErrorHandler;
